import React from 'react'
import styled from 'styled-components';
import DarkLogo from 'assets/imgs/logos/logo.png';


const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: auto;
  z-index: 100;
  background-color: transparent;
  padding: 0 0rem .5rem 1.25rem;

  p {
    font-size: 0.5rem;
    text-transform: uppercase;
    margin: 0;
    padding: 0;
    line-height: 1.25em;
    vertical-align: baseline;
    text-align: center;

    img {
      height: .75rem;
      vertical-align: middle;
      padding-left: .15rem;
      padding-bottom: .2rem;
      box-sizing: content-box;
    }
  }
`

const NwBookCredits = () => {
    return (
        <FooterWrapper>
            <p>
                <a href="https://www.netwalk.eu" target="_blank">
                    powered by
                    <br />
                    <img className="nw-logo" src={DarkLogo} alt="NETWALK4" />
                </a>
            </p>
        </FooterWrapper>
    )
}

export default NwBookCredits
